import React from 'react';
import { steps } from '../utils';
import Stepper from '../../../collectPayment/stepper';
import { useGetExamChargesContext } from '../../context';
import { pageStateMapping } from '..';

const StepperWrapper = () => {
    const {currentStep , setCurrentPageState , setCurrentStep , amountToBePaid , totalCollectedAmount} = useGetExamChargesContext();
    const amountToBePaidCollected = amountToBePaid === totalCollectedAmount;

    const handleStepClick = (stepIndex) => {

        if(stepIndex === 1 && !amountToBePaidCollected) return;

        setCurrentStep(stepIndex);
        setCurrentPageState(Object.keys(pageStateMapping)[stepIndex]);
    }

    return ( 
        <Stepper numberOfSteps={steps.length} steps={steps} currentStep={currentStep} handleStepClick={handleStepClick} />
     );
}
 
export default StepperWrapper;